import React from 'react'
import GLoading from 'tennders-market/common/components/element/GLoading'
import GHref from 'tennders-market/common/components/element/GHref'
import useInputFile from '../hooks/useInputFile'

type Props = {
  url ?: string,
  buttonClass ?: string,
  id ?: string | number,
  next ?: (data : Record<string, any>) => void
  children?: React.ReactNode | React.ReactNode[],
  params ?: Record<string, any>
}

const GInputFile = (props : Props) => {
  const {
    params,
    children,
    url,
    buttonClass,
    id,
    next
  } = props

  const {
    submitting,
    upload
  } = useInputFile({
    params,
    url,
    next
  })
  const fileRef = React.createRef<HTMLInputElement>()

  const extensions = [
    'application/eml',
    'image/*',
    'application/pdf',
    'text/plain',
    'application/vnd.ms-outlook',
    'application/doc',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ]

  const onInputClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    const element = event.target as HTMLInputElement
    element.value = ''
  }

  return (
    <>
      <GHref
        className={buttonClass}
        disabled={submitting}
        onClick={
          submitting
            ? () => null
            : () => fileRef.current.click()
        }
      >
        {children}
        {submitting && <GLoading size={14} />}
      </GHref>
      <input
        hidden
        ref={fileRef}
        id={`file${id}`}
        type="file"
        onChange={(e) => upload(e)}
        onClick={onInputClick}
        accept={extensions.join(',')}
        className="add-collection-img"
      />
    </>
  )
}

export default GInputFile
